import { useGenericRequestHandler } from '../../../handlers'

export const useAccountNotificationPreferences = () => {
  return useGenericRequestHandler({
    route: 'i/notifications',
    method: 'POST'
  })
}
